import OrderAction from './orderAction';
import Attendee from '../../../models/attendeeModel';
import Refund from '../../attendee/actions/refund';
import RefundPostAction from '../../attendee/post-action/refundPostAction';
import Order from '../models/orderModel';
import { fetcher } from '@weezevent/weezjs-core';
import RefundAdditionalContent from '../../attendee/actions/additionalContent/refund';

export default class RefundOrder extends OrderAction {
    static NAME = 'refund';
    static POST_ACTION_COMPONENT = RefundPostAction;
    static ADDITIONNAL_CONTENT_MODAL = RefundAdditionalContent;
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    constructor(props) {
        super(props);
        this.refund_type = 'all';
    }

    setRefundType(type) {
        this.refund_type = type;
    }

    static condition(order) {
        const refundRequest = order.refund_requests ? order.refund_requests.filter(r => !r.removed) : null;
        let refundRequest_ids = new Set();
        if (refundRequest) {
            refundRequest.forEach(r => refundRequest_ids.add(r.attendee));
        }
        const hasRefunded = refundRequest_ids.size === order.attendee_count ? true : false;

        return (
            (order.attendee_count === order.attendees_deleted_count || order.internal_transaction) &&
            order.origin !== 'weez_invitation' &&
            order.origin !== 'weez_ticketoffice' &&
            Number(order.price_ticket) > 0 &&
            !hasRefunded &&
            super.payment_plan_condition(order)
        );
    }

    static is_attendee_valid({ attendee, order }) {
        return Refund.is_attendee_valid({ attendee, order });
    }

    static is_available({ event }) {
        return !['closed'].includes(event.status) && !event.removed;
    }

    run({ attendees = null, orders = null, organization, event }) {
        if (attendees) {
            const to_refund = attendees.filter(a => !a.removed || !a.scanned);
            this.filtered_attendees = to_refund;
        }
        this.filtered_orders = orders || this.filtered_items;
        if (this.filtered_orders.length >= this.constructor.ASYNCHRONOUS_LIMIT_MIN) {
            this.total_orders = this.filtered_orders.length;
            this.mode = this.constructor.TYPE;
            return Promise.resolve(true);
        }

        let options = {
            dry_run: true,
            refund_charges: true
        };

        if (this.refund_type !== 'all') {
            options[this.refund_type] = true;
        }

        return fetcher
            .post(`/ticket/organizations/${this.organization.id}/events/${this.event.pk}/refund`, {
                data: {
                    options: options,
                    ...(this.filtered_attendees && { attendee_ids: this.filtered_attendees.map(attendee => attendee.id) }),
                    ...(this.filtered_orders && !attendees && { order_ids: this.filtered_orders.map(order => order.pk) })
                }
            })
            .then(response => response.json())
            .then(json => {
                this.total_amount = json.amount;
                if (attendees) {
                    const to_refund = attendees.filter(a => !a.removed || !a.scanned);
                    this.filtered_attendees = to_refund;
                    this.total_attendees = attendees.length;
                    this.mode = Refund.TYPE;
                    return true;
                }

                this.total_orders = this.filtered_orders.length;
                this.mode = this.constructor.TYPE;
                return true;
            });
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }

    get post_action() {
        return true;
    }

    get withToastRun() {
        return false;
    }

    runPostAction({ items, mode, delete_all }) {
        if (mode === 'attendees') {
            return Attendee.perform_action(Refund.NAME, items, { organization: this.organization, event: this.event, delete_all, refund_type: this.refund_type });
        }

        return Order.perform_action(
            this.constructor.NAME,
            items,
            { organization: this.organization, event: this.event, delete_all, refund_type: this.refund_type },
            this.isAsync(items)
        );
    }
}
